// src/components/card/CardTab.jsx
import React from 'react';
import cardTab from '../../assets/card_tab.png';
import { anchorStyle } from './anchor';
import { tabFont } from './ui';
import { LEVELS, levelIndex } from './layout';

export default function CardTab({ px, pos, anchor = 'tl', level }) {
  const { x, y, w } = pos;
  const active = levelIndex(level);
  const TEXT_OFFSET_Y = 26;

  return (
    <div
      style={{
        ...anchorStyle(px, { x, y, anchor }), // 左上錨點
        width: px(w),
        height: 'auto',
        position: 'absolute',
        zIndex: 0,              // ← 永遠在最底，不遮文字
        pointerEvents: 'none',
      }}
    >
      <img src={cardTab} alt="" style={{ width: '100%', height: 'auto', display: 'block' }} />

      {/* 分頁四標題（自動高亮） */} 

      <div
        style={{
          position: 'absolute',  
          left: 0,
          top: px(TEXT_OFFSET_Y),
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          paddingLeft: px(110),
          paddingRight: px(110),
          paddingTop: px(24),
        }}
      >
        {LEVELS.map((t, i) => (
          <div
            key={t}
            style={{
              ...tabFont,
              opacity: i === active ? 1 : 0.6,
              filter: i === active ? 'drop-shadow(0 1px 1px rgba(0,0,0,.25))' : 'none',
              marginTop: px(24),
            }}
          >
            {t}
          </div>
        ))}
      </div>
    </div>
  );
}
